import { render } from "./ComponenteInputFotovoltaica.vue?vue&type=template&id=b47fe4be&scoped=true"
import script from "./ComponenteInputFotovoltaica.vue?vue&type=script&lang=js"
export * from "./ComponenteInputFotovoltaica.vue?vue&type=script&lang=js"

import "./ComponenteInputFotovoltaica.vue?vue&type=style&index=0&id=b47fe4be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b47fe4be"]])

export default __exports__